import { Alert, CardHeader, Paper, Table, TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import axios from "axios";
import * as React from "react";
import { Config } from "../../config/config";
import { Helpers } from "../../utils/helpers";
import { PopupMessage } from "../../utils/message";
import { ABTestingCreateTest } from "./createTest";

export class ABtesting extends React.Component<any, any> {
    constructor(props) {
        super(props);

        this.state = {
            tests: [],
            loaded: false,
        };

        document.title = Helpers.documentTitle("AB testing");
    }

    componentDidMount() {
        this.getTests();
    }

    refreshData = () => {
        this.getTests();
    }

    getTests = async () => {
        try {
            const response = await axios.get(`${Config.getInstance.apiUrl}/api/abtests`, {
                headers: {
                    Authorization: Helpers.getSessionId(),
                    env: this.props.activeEnv,
                },
            });

            this.setState({ tests: response.data?.data || [], loaded: true });
        } catch (error) {
            PopupMessage.error("Couldn't fetch list with active tests");
        }
    }

    renderPendings(versions: any[]) {
        return Object.keys(versions).map(version => (
            <div key={version}>{version}: {versions[version]}</div>
        ));
    }

    renderTableContent() {
        if (!this.state.loaded) {
            return <TableRow key="loading-row">
                <TableCell colSpan={8}>
                    {Helpers.renderSkeletonRows(5, 50)}
                </TableCell>
            </TableRow>
        }

        if ((this.state?.tests || []).length === 0) {
            return <TableRow key="records_not_found">
                <TableCell colSpan={8}>
                    <Alert severity="info">No Tests</Alert>
                </TableCell>
            </TableRow>
        }

        return (this.state?.tests || []).map(test => (
            <TableRow key={test.id}>
                <TableCell>{test?.name || null}</TableCell>
                <TableCell>{test?.status || null}</TableCell>
                <TableCell>{test?.description || null}</TableCell>
                <TableCell>{new Date(test?.start_at || "").toLocaleString()}</TableCell>
                <TableCell>{new Date(test?.end_at || "").toLocaleString()}</TableCell>
                <TableCell>{this.renderPendings(test?.pending || [])}</TableCell>
                <TableCell>{test?.pending_count || 0}</TableCell>
                <TableCell>
                    <ABTestingCreateTest type="edit" defaultValues={test} refreshData={this.refreshData} {...this.props}/>
                </TableCell>
            </TableRow>
        ));
    }

    render() {
        return <div className="contentPadding">
            <Paper className="root" elevation={0}>
                 <CardHeader
                    title="AB tests"
                    action={
                        <ABTestingCreateTest type="new" defaultValues={{}} refreshData={this.refreshData} {...this.props}/>
                    }
                />

                <Table aria-label="AB testing list">
                    <TableHead>
                        <TableRow>
                            <TableCell>Name</TableCell>
                            <TableCell>Status</TableCell>
                            <TableCell>Description</TableCell>
                            <TableCell>Start time</TableCell>
                            <TableCell>End time</TableCell>
                            <TableCell>Pending</TableCell>
                            <TableCell>Pending total</TableCell>
                            <TableCell></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {this.renderTableContent()}
                    </TableBody>
                </Table>
            </Paper>
        </div>;
    }
}
